import { createAction, props } from '@ngrx/store';

enum LoginActionType {
  setTokenAction = '[LoginComponent] Set token',
  resetStateAction = '[LoginComponent] Reset state',
  errorAction = '[LoginComponent] Error action',
  refreshTokenAction = '[LoginComponent] Refresh token action',
  findTokenAction = '[LoginComponent] initSesion',
  setRolAction = '[LoginComponent] Set rol',
}

const setToken = createAction(
  LoginActionType.setTokenAction,
  props<{ token: string }>()
);
const resetState = createAction(LoginActionType.resetStateAction, props<any>());

const onError = createAction(LoginActionType.errorAction, props<{ error: string }>());

const refreshToken = createAction(LoginActionType.refreshTokenAction, props<any>());

const initSesion = createAction(LoginActionType.findTokenAction, props<any>());

const setRol = createAction(LoginActionType.setRolAction, props<{ rolId: string | null, rolName: string | null }>());

export const LoginAction = {
  initSesion,
  setToken,
  resetState,
  onError,
  refreshToken,
  setRol,
};
